import { render, staticRenderFns } from "./need-auth-in-service.vue?vue&type=template&id=422b8c16&scoped=true"
import script from "./need-auth-in-service.vue?vue&type=script&lang=js"
export * from "./need-auth-in-service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422b8c16",
  null
  
)

export default component.exports